import messages from '../assets/locales/messages_en.json';
import { supportedHeaderLanguages } from './header';

export type SupportedHeaderLanguage = typeof supportedHeaderLanguages[number];

export const SEPARATOR = 'SEPARATOR';

export type Separator = typeof SEPARATOR;

export type TextKey = keyof typeof messages;

export interface UserMenuData {
  signOut: NavigationItem;
  mySites: NavigationItem;
  userNav: NavigationItem[];
}

export type HeaderStructure = (NavigationItemForAllLanguages | Separator)[];
export type NavigationStructure = (NavigationItem | Separator)[];

export type NavigationItemForAllLanguages = {
  text: string;
  description?: TextKey;
  href?: LanguageHrefMap;
  name?: string;
  lang?: SupportedHeaderLanguage[];
  target?: '_blank';
  subs?: NavigationItemForAllLanguages[];
  mobileOnly?: boolean;
};

export type NavigationItem = Omit<NavigationItemForAllLanguages, 'href' | 'subs' | 'lang'> & {
  href?: string;
  subs?: NavigationItem[];
};

export type LanguageHrefMap = Partial<Record<SupportedHeaderLanguage, string>> | string;
